import { useEffect, useRef } from "react";

type LoadMoreSentinelOptions = {
  hasMore: boolean;
  isLoadingMore: boolean;
  onLoadMore: () => void;
  rootMargin?: string;
};

export function useLoadMoreSentinel({
  hasMore,
  isLoadingMore,
  onLoadMore,
  rootMargin = "100px",
}: LoadMoreSentinelOptions) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element || !hasMore || isLoadingMore) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) onLoadMore();
      },
      { rootMargin },
    );
    observer.observe(element);
    return () => observer.disconnect();
  }, [hasMore, isLoadingMore, onLoadMore, rootMargin]);

  return ref;
}
